webpackJsonp([9],{

/***/ "+1JM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

FollowersSvcFactory.$inject = ["$rootScope", "$location", "$stateParams", "$filter", "HttpSvc"];
Object.defineProperty(exports, "__esModule", { value: true });
var FollowersSvc = (function () {
    function FollowersSvc(sameUser, state, updateFollowingsOnStart) {
        if (updateFollowingsOnStart === void 0) { updateFollowingsOnStart = true; }
        var _this = this;
        this.sameUser = sameUser;
        this.state = state;
        this.updateFollowingsOnStart = updateFollowingsOnStart;
        this.busy = false;
        this.following = [];
        this.myFollowing = [];
        this.baseRelationship = function (username) {
            return _this.HttpSvc('relationships', _this.$filter('encodeUsername')(username));
        };
        if (state !== 'studio-following' && state !== 'studio-followers') {
            throw new Error('state should be either "following" or "followers". Found ' + JSON.stringify(state));
        }
        if (this.$location.search().startFollowing && !options.user.anonymous) {
            this.$location.url(this.$location.path()).replace();
            this.follow({ username: this.$stateParams.username });
        }
        if (updateFollowingsOnStart) {
            this.updateFollowing(this.$stateParams.username);
        }
        else {
            this.updateMyFollowing();
        }
    }
    FollowersSvc.prototype.updateFollowing = function (username) {
        var _this = this;
        this.busy = true;
        this.updateMyFollowing();
        if (!this.sameUser || this.state === 'studio-followers') {
            this.updateFollowings(username, this.state).then(function (data) {
                if (angular.isArray(data))
                    _this.following = data;
                _this.busy = false;
                _this.$rootScope.$emit('$following:loaded');
            });
        }
    };
    ;
    FollowersSvc.prototype.updateMyFollowing = function () {
        var _this = this;
        return this.updateFollowings(this.$rootScope.user.username, 'studio-following').then(function (data) {
            _this.myFollowing = data;
            if (_this.sameUser && _this.state === 'studio-following') {
                _this.following = data;
                _this.busy = false;
            }
        });
    };
    ;
    FollowersSvc.prototype.isFollowing = function (user) {
        return _.some(this.myFollowing, { username: user.username });
    };
    ;
    FollowersSvc.prototype.follow = function (user) {
        var _this = this;
        this.baseRelationship(user.username).securePost().then(function () {
            _this.myFollowing.push(user);
            user.followers += 1;
        });
    };
    ;
    FollowersSvc.prototype.unfollow = function (user) {
        var _this = this;
        this.baseRelationship(user.username).secureDelete().then(function () {
            _this.myFollowing = _.reject(_this.myFollowing, { username: user.username });
            user.followers -= 1;
        });
    };
    ;
    FollowersSvc.prototype.updateFollowings = function (username, state) {
        var _this = this;
        return this.baseRelationship(username)
            .chain(state.replace('studio-', ''))
            .get()
            .catch(function () { return _this.busy = false; })
            .then(function (r) { return r.data; });
    };
    ;
    return FollowersSvc;
}());
exports.FollowersSvc = FollowersSvc;
function FollowersSvcFactory($rootScope, $location, $stateParams, $filter, HttpSvc) {
    _.extend(FollowersSvc.prototype, {
        $rootScope: $rootScope, $location: $location, $stateParams: $stateParams, $filter: $filter, HttpSvc: HttpSvc,
    });
    return FollowersSvc;
}
angular.module('animatronApp.profileProject').service('FollowersSvc', FollowersSvcFactory);


/***/ }),

/***/ "3Pz5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var RescaleSvc_1 = __webpack_require__("7T+Z");
var underscore_extensions_1 = __webpack_require__("R0iF");
var ProfileProjectCtrl = (function () {
    ProfileProjectCtrl.$inject = ["$scope", "$rootScope", "$stateParams", "$q", "AnimatronProjects", "AnimatronPreviews", "HttpSvc", "Player", "AuthenticationSvc"];
    function ProfileProjectCtrl($scope, $rootScope, $stateParams, $q, AnimatronProjects, AnimatronPreviews, HttpSvc, Player, AuthenticationSvc) {
        var _this = this;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$stateParams = $stateParams;
        this.$q = $q;
        this.AnimatronProjects = AnimatronProjects;
        this.AnimatronPreviews = AnimatronPreviews;
        this.HttpSvc = HttpSvc;
        this.Player = Player;
        this.AuthenticationSvc = AuthenticationSvc;
        this.customize = $stateParams.customize;
        this.setBgColorFromMovie = $stateParams.bgColor;
        this.pickPreview = AnimatronPreviews.pickPreview;
        this.playerId = 'profile-project';
        this.pickProjectEl = document.querySelector('.pick-project');
        if (this.customize)
            this.pickUserProject();
        this.watchForLink($scope);
        $scope.$watch(function () { return options.user.username === decodeURIComponent($stateParams.username); }, function (val) { return _this.canPick = val; });
        $rootScope.$on('project:remove', function (e, projectId) {
            if (_this.projectId === projectId)
                _this.removeProject();
        });
    }
    ProfileProjectCtrl.prototype.onTabChange = function (tab) {
        if (tab === 'standard-animations') {
            this.animatron = this.getStandartProjects();
        }
        else if (tab === 'my-animations') {
            this.animatron = angular.copy(this.myProjects());
            this.animatron.changeLimit(8);
        }
        if (tab) {
            this.currentPage = 1;
            this.loadProjects();
        }
    };
    ProfileProjectCtrl.prototype.getStandartProjects = function () {
        if (!this.standartProjects) {
            this.standartProjects = new this.AnimatronProjects({
                limit: 8,
                tag: 'Standard-Profile',
                tag_type: 'SUPER',
                sortBy: 'tag_creation_time'
            });
        }
        return this.standartProjects;
    };
    ProfileProjectCtrl.prototype.loadProjects = function () {
        if (this.animatron.results.length === 0) {
            this.animatron.loadPage(this.currentPage);
        }
    };
    ProfileProjectCtrl.prototype.pickUserProject = function () {
        this.choosen = null;
        this.projectPickerShown = true;
        this.tabs = ['standard-animations'];
        if (this.myProjects().count > 0) {
            this.tabs.push('my-animations');
        }
        this.currentTab = this.tabs[this.tabs.indexOf(this.customize)] || this.tabs[0];
    };
    ProfileProjectCtrl.prototype.pickChosenProject = function (choosenProject) {
        this.AuthenticationSvc.extendUser({ meta: { profileProject: choosenProject.id } });
        this.HttpSvc('profile/profile-project').securePut(choosenProject.id);
        this.projectPickerShown = false;
        this.projectId = choosenProject.id;
    };
    ProfileProjectCtrl.prototype.resetPlayer = function () {
        return this.Player.resetPlayerById(this.playerId);
    };
    ProfileProjectCtrl.prototype.removeProject = function () {
        this.HttpSvc('profile/profile-project').secureDelete();
        this.projectId = undefined;
        this.AuthenticationSvc.extendUser({ meta: { profileProject: undefined } });
        return this.resetPlayer();
    };
    ProfileProjectCtrl.prototype.watchForLink = function ($scope) {
        var _this = this;
        $scope.$watch(function () { return _this.projectId; }, function (id) {
            if (angular.isString(id) && id.length === 24) {
                _this.loading = true;
                _this.HttpSvc('project', _this.projectId).get().then(function (r) { return r.data; }).then(function (response) {
                    if (underscore_extensions_1.Utils.isApiError(response))
                        return _this.$q.reject(_this.loading = false);
                    return _this.$q.all([_this.Player.getProjectUrl(response), _this.resetPlayer()]);
                }).then(function (_a) {
                    var link = _a[0];
                    return _this.Player.createPlayer(link.replace('http:', 'https:'), _this.playerId, {
                        ribbonsColor: 'transparent',
                        autoPlay: true,
                        audioEnabled: false,
                        controlsEnabled: false
                    });
                }).then(function (player) {
                    _this.loading = false;
                    if (_this.setBgColorFromMovie) {
                        document.querySelector('.user-section').style['background-color'] = player.anim.bgfill._style;
                    }
                    _this.$rootScope.$on('notOnScreen:' + _this.playerId, function () { return player && player.pause(); });
                    _this.$rootScope.$on('onScreen:' + _this.playerId, function () { return player && player.play(Math.max(0, player.getTime())); });
                    _this.resizePlayerFunc(player)();
                    var func = _.throttle(_this.resizePlayerFunc(player), 500);
                    underscore_extensions_1.Utils.scopedEvent('resize', $scope, func);
                }).catch(function () {
                    _this.loading = false;
                    _this.projectId = null;
                });
            }
        });
        $scope.$on('$destroy', function () { return _this.resetPlayer(); });
    };
    ProfileProjectCtrl.prototype.resizePlayerFunc = function (player) {
        var _this = this;
        return function () {
            if (!player)
                return;
            var userSectionRect = _this.getBoundingRectOfUserSection();
            var dim = RescaleSvc_1.RescaleSvc.resizeWithAspectRatio(player.width * 9999, player.height * 9999, window.innerWidth - 32, userSectionRect.height);
            player.setSize(dim.width, dim.height);
        };
    };
    ProfileProjectCtrl.prototype.getBoundingRectOfUserSection = function () {
        this.pickProjectEl.style.position = 'absolute';
        var selector = document.querySelector('.user-section');
        var userSectionRect = selector && selector.getBoundingClientRect();
        this.pickProjectEl.style.position = 'relative';
        return userSectionRect;
    };
    return ProfileProjectCtrl;
}());
exports.ProfileProjectCtrl = ProfileProjectCtrl;
angular.module('animatronApp.profileProject').directive('profileProject', function () {
    return {
        restrict: 'E',
        scope: {
            projectId: '=',
            myProjects: '&'
        },
        controller: ProfileProjectCtrl,
        controllerAs: 'ProfileProjectCtrl',
        bindToController: true,
        templateUrl: __webpack_require__("Md20")
    };
});


/***/ }),

/***/ "Md20":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/profile-project_fb15db0dcc5567d463355ab246e2136a.html";

/***/ }),

/***/ "dMZG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var underscore_extensions_1 = __webpack_require__("R0iF");
var FollowingCtrl = (function () {
    FollowingCtrl.$inject = ["$scope", "$rootScope", "$state", "$stateParams", "HttpSvc", "FollowersSvc"];
    function FollowingCtrl($scope, $rootScope, $state, $stateParams, HttpSvc, FollowersSvc) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.HttpSvc = HttpSvc;
        this.FollowersSvc = FollowersSvc;
        $scope.subjectUser = $stateParams.user;
        $scope.stateName = $state.current.name;
        $scope.subjectUser = {
            username: $stateParams.username
        };
        $scope.sameUser = options.user.username === $scope.subjectUser.username;
        $scope.followersSvc = new FollowersSvc($scope.sameUser, $state.current.name);
        if ($scope.sameUser) {
            $scope.subjectUser = options.user;
        }
        else {
            updateProfile();
        }
        $scope.$watch('subjectUser', function (u) {
            return $rootScope.setTitle($scope.stateName + '.title', u.displayName);
        });
        function updateProfile() {
            HttpSvc($scope.subjectUser.username, 'profile').get()
                .then(function (response) {
                var user = response.data;
                if (underscore_extensions_1.Utils.isUser(user)) {
                    $rootScope.setTitle($scope.stateName + '.title', user.displayName);
                    $scope.subjectUser = user;
                }
                else {
                    $state.go('studio-explore');
                }
            });
        }
    }
    return FollowingCtrl;
}());
angular.module('animatronApp.profileProject').component('followersPage', {
    controller: FollowingCtrl,
    templateUrl: __webpack_require__("jPnc")
});


/***/ }),

/***/ "dTsy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/pagination_7e2f3628d90bcbe84e3ab54031620654.html";

/***/ }),

/***/ "jPnc":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/following_12116117825ee99ab9d8b0ac210d2599.html";

/***/ }),

/***/ "pD8l":
/***/ (function(module, exports, __webpack_require__) {

var PaginationCtrl = (function () {
    PaginationCtrl.$inject = ["$scope", "$element"];
    function PaginationCtrl($scope, $element) {
        var _this = this;
        this.$scope = $scope;
        this.$element = $element;
        this.maxSize = 5; //  maximum count pages into pagination
        this.pages = []; // container for number of pages
        this.enable = true; // show or hide general element
        this.ngModelCtrl = this.$element.controller('ngModel');
        this.ngModelCtrl.$render = function () { return _this.render(); };
        // calculate new values if totalPages is changed
        $scope.$watch(function () { return _this.totalPages; }, function (val) {
            if (val) {
                _this.enable = _this.totalPages > 1;
                _this.currentMaxSize = _this.totalPages >= _this.maxSize ? _this.maxSize : _this.totalPages;
                _this.render();
            }
        });
    }
    PaginationCtrl.prototype.render = function () {
        var viewValue = parseInt(this.ngModelCtrl.$viewValue, 10) || 1;
        if (viewValue > 0 && viewValue <= this.totalPages) {
            this.page = viewValue;
            this.noPrevious = viewValue === 1;
            this.noNext = viewValue === this.totalPages;
            this.createPages();
        }
    };
    PaginationCtrl.prototype.createPages = function () {
        this.pages = [];
        var startPage = Math.max(this.page - Math.floor(this.currentMaxSize / 2), 1), endPage = startPage + this.currentMaxSize - 1;
        if (endPage > this.totalPages) {
            endPage = this.totalPages;
            startPage = endPage - this.currentMaxSize + 1;
        }
        // Add page number
        for (var number = startPage; number <= endPage; number++) {
            this.pages.push({
                value: number,
                text: number,
                active: number === this.page
            });
        }
    };
    PaginationCtrl.prototype.selectPage = function (page) {
        if (this.page !== page && page > 0 && page <= this.totalPages) {
            this.ngModelCtrl.$setViewValue(page);
            this.ngModelCtrl.$render();
        }
    };
    return PaginationCtrl;
}());
angular.module('animatronApp.profileProject').component('pagination', {
    require: { ngModelCtrl: 'ngModel' },
    bindings: {
        totalPages: '=',
        maxSize: '=?'
    },
    controller: PaginationCtrl,
    controllerAs: 'PaginationCtrl',
    templateUrl: __webpack_require__("dTsy")
});


/***/ }),

/***/ "vpuT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AdSvc_1 = __webpack_require__("X7JN");
var underscore_extensions_1 = __webpack_require__("R0iF");
var Strings_1 = __webpack_require__("fxc3");
var UserCtrl = (function () {
    UserCtrl.$inject = ["$scope", "$rootScope", "$stateParams", "$state", "FollowersSvc", "$filter", "HttpSvc", "AnimatronProjects"];
    function UserCtrl($scope, $rootScope, $stateParams, $state, FollowersSvc, $filter, HttpSvc, AnimatronProjects) {
        var _this = this;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.FollowersSvc = FollowersSvc;
        this.$filter = $filter;
        this.HttpSvc = HttpSvc;
        this.AnimatronProjects = AnimatronProjects;
        this.tabs = ['your', 'contest', 'join', 'init'];
        this.currentTab = this.$stateParams.page || this.tabs[0];
        $scope.AdSvc = new AdSvc_1.AdSvc(false, this.$rootScope);
        $scope.enableProfileProject = true;
        $scope.sameUser = Strings_1.Strings.sameUser($stateParams.username);
        var subjectUser = $filter('encodeUsername')($stateParams.username);
        var adify = this.$scope.AdSvc.adify.bind(this.$scope.AdSvc);
        if ($scope.sameUser) {
            var state = this.$stateParams.removed ? 'REMOVED' : 'ACTIVE';
            $scope.animatron = new AnimatronProjects({ state: state }, true, '', adify);
            this.load(options.user);
        }
        else {
            $scope.animatron = new AnimatronProjects({ username: subjectUser }, false, '', adify);
            $scope.animatronUser = $scope.animatron.projectsAuthor = $stateParams.user;
            HttpSvc(subjectUser, 'profile').get().then(function (r) { return r.data; }).then(function (response) {
                if (underscore_extensions_1.Utils.isUser(response)) {
                    _this.load(response);
                }
                else {
                    _this.userNotFound = true;
                    document.head.querySelector('[name=robots]').content = 'noindex';
                    document.head.querySelector('[name=prerender-status-code]').content = '404';
                }
            });
        }
    }
    UserCtrl.prototype.load = function (user) {
        var _this = this;
        this.$rootScope.setTitle('user.title', user.displayName);
        if (!this.$scope.sameUser) {
            this.$scope.animatronUser = this.$scope.animatron.projectsAuthor = user;
        }
        else {
            this.$scope.$watch(function () { return options.user; }, function (val) {
                return _this.$scope.animatron.projectsAuthor = _this.$scope.animatronUser = val;
            });
        }
        this.$scope.followersSvc = new this.FollowersSvc(this.$scope.sameUser, 'studio-following');
    };
    UserCtrl.prototype.onTabChange = function (tab) {
        var page = tab === 'your' ? null : tab;
        this.$state.go('.', { page: page }, { notify: false });
        if (tab === 'your') {
            this.$rootScope.$emit('masonry:layout');
        }
    };
    return UserCtrl;
}());
angular.module('animatronApp.profileProject').component('userPage', {
    controllerAs: 'UserCtrl',
    controller: UserCtrl,
    templateUrl: __webpack_require__("0MDI")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/9-bd880478516a225297ea.min.js